import React, { FC, ReactNode, useState } from 'react';
import { StyledModal } from './CustomModal.styles';
import ScheduleModalFooter from '../../components/ScheduleSurvey/ScheduleContent/ModalFooter/ModalFooter';
import CloseMark from '@/assets/icons/closeMark.svg?react';

interface CustomModalProps {
  triggerButton: React.ReactNode;
  header: ReactNode;
  body: ReactNode;
}

const CustomModal: FC<CustomModalProps> = ({ triggerButton, header, body }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div onClick={showModal} style={{ display: 'inline-block' }}>
        {triggerButton}
      </div>
      <StyledModal
        title={header}
        open={isModalOpen}
        onCancel={handleCancel}
        closeIcon={<CloseMark />}
        footer={<ScheduleModalFooter />}
      >
        {body}
        {/* HTML here */}
        {/* footer, do we really need it? */}
      </StyledModal>
    </>
  );
};

export default CustomModal;
